// constants/colors.js

/**
 * Цветовая схема для дождевальных машин (ДМ)
 */
export const DM_COLORS = {
    // Онлайн режим
    ONLINE: {
      // С водой (работает)
      WATER_FILL: 'rgba(40, 165, 237, 0.5)',
      WATER_STROKE: 'rgba(22, 161, 242, 0.6)',
      
      // Без воды (ожидание)
      NOWATER_FILL: 'rgba(37, 240, 14, 0.5)',
      NOWATER_STROKE: 'rgba(35, 240, 12, 0.7)',
    },
    
    // Офлайн режим (нет связи)
    OFFLINE: {
      FILL: '#dedcdcb3',
      STROKE: '#b8b4b4',
    }
  };
  
  /*Цветовая схема для насосных станций (РС/RS485)*/
  export const RS_COLOR = {
    DEFAULT: { fill: '#05f59f', stroke: '025e3e' }, //аквамарин
    ISNOLINK: { fill: '#dedcdcb3', stroke: '#b8b4b4' }, //серый
    ISNOCONNECT: { fill: '#cf0bf1', stroke: '#a60ac2' },//Фиолетовый
    READY: { fill: '#F0E256', stroke: '#ebda28' }, //Желтый
    RUN: { fill: '#3ABF1D', stroke: '#2c9116' }, //зеленый
    ALARM: { fill: '#F03118', stroke: '#c9220c' } //Красны  
  };
  
  /**
   * Цвета для линий и других элементов
   */
  export const MAP_ELEMENTS_COLORS = {
    // Линии
    CURRENT_LINE: '#ff0000',           // Текущее положение
    OFFSET_LINE: '#e8fc00',            // Нулевое положение
    BARRIER_LINE: '#808080',           // Линии барьеров
    ARC_LINE: 'rgba(128, 128, 128, 0.7)', // Дуга разрешенной зоны
    
    // Контуры
    ACTIVE_OUTLINE: 'rgba(255, 162, 3, 1)', // Обводка активного устройства
    
    // Центральные точки
    CENTER_POINT: '#ff0000',           // Центральная точка круга
    
    // Треугольники-стрелки
    TRIANGLE_ONLINE: '#ff0000',
    TRIANGLE_OFFLINE: '#dedcdcb3',
    
    // Текстовые метки
    LABEL_ICON: 'transparent',
    LABEL_TEXT_COLOR: 'black',
  };
  
  /**
   * Общая палитра (если нужны базовые цвета)
   */
  export const BASE_COLORS = {
    RED: '#ff0000',
    GREEN: '#00ff00',
    BLUE: '#0000ff',
    YELLOW: '#ffff00',
    GRAY: '#808080',
    LIGHT_GRAY: '#dedcdc',
    WHITE: '#ffffff',
    BLACK: '#000000',
  };
  